<template>
  <div ref='pc' class="pc">
    <div class="header" :style="'background-color:' + (headerTop ? 'rgba(248,248,248,1)' : '')">
      <div class="h_cont">
        <div :class="{'logo':true,'headerTop':headerTop}"></div>
      </div>
      <div class="tipBox">
        <div :class="{'tip':true,'tipcolor':headerTop}">
          <span v-for="(item, index) in routerList" :class="{'active':item.active}" :key="index" @click="toRouter(index)">{{item.tit}}</span>
        </div>
      </div>
    </div>
    <div id="pc_top" class="pc_top_box">
        <div class="pc_top">
            <div class="pc_top_cont">
                <div>
                    <img src="../assets/black.png" alt="">
                </div>
                <div class="pc_cont">
                    <div class="pc_cont_box">
                        <p class="pc_cont_tit">小品出行</p>
                        <p class="pc_cont_tip">中国互联网出行助力车平台</p>
                    </div>
                    <div class="pc_cont_text">
<!--                        <span>-->
<!--                        顺应出行经济环境浪潮，将自行车轻巧灵便的优势与电动车 <br>-->
<!--                        省力续航强的优点结合起来，通过布局大型商业综合体、写 <br>-->
<!--                        字楼、中高端社区、大型公交枢纽、机场、景区等区域，为 <br>-->
<!--                        用户提供全新的出行方式，缓解城市的交通问题。-->
<!--                        </span>-->
                        <span>
                        顺应出行经济环境浪潮，“小品出行”依托团队强大的技术<br>
                        实力，通过布局大型商业综合体、写字楼、中高端社区、大<br>
                        型公交枢纽、机场、景区等区域，为用户提供全新的出行方<br>
                        式，努力打造共享出行2.0模式，更好解决市民出行“最后<br>
                        三至十公里”问题，缓解城市交通问题。
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <p class="pc_top_bottem"><span>为什么要选择小品?</span></p>
    </div>
    <div id="xpadVantage" class="xpadVantage">
      <div class="xpadVantage_tit">
        <p><span>小品助力，坐享骑程</span></p>
      </div>
      <div class="xpadVantage_detail">
        <div class="detail_item">
          <div class="item_title">
            <p><img src="../assets/pollution_reduction.png" alt=""><span>减少环境污染</span></p>
            <div class="item_text">
              <span>小品出行公共电助车采用超威环保锂电池作为主要动力源，可以做到零排放，小品出行采取统一采购、统一回收、统一处理。有效避免电池随意丢弃处置造成的环境污染</span>
            </div>
          </div>
        </div>
        <div class="detail_item">
          <div class="item_title">
            <p><img src="../assets/traffic_safety.png" alt=""><span>增加交通安全</span></p>
            <div class="item_text">
              <span>小品出行每一辆公共电助车均符合2019年4月15日最新颁布的《电动自行车安全技术规范》，通过国家3C认证，并且进入浙江省电动车目录。小品出行公共电助车与国内知名保险集团中国人寿合作，为小品出行公共电助车进行投保，保险涵盖意外险、医疗险。</span>
            </div>
          </div>
        </div>
        <div class="detail_item">
          <div class="item_title">
            <p><img src="../assets/battery_management.png" alt=""><span>电池管理安全</span></p>
            <div class="item_text">
              <span>小品出行公共电助车的电池充电管理是科学的且符合规范的，首先，我们会在长兴建设专业的充电场所作为电池充电存放，电池充电存放场所全权委托超威集团建设提供技术规范和安全规范，使充放场所完全合规。</span>
            </div>
          </div>
        </div>
        <div class="hr"></div>
      </div>
    </div>
    <div id="xpTraffic" class="xpTraffic">
      <div class="xpTraffic_detail">
        <p class="explain"><span>小品助力，共享骑程</span></p>
        <p class="xpTraffic_title"><span>减少交通压力</span></p>
        <div class="xpTraffic_text">
          <span>
            小品出行为每一辆电助车配备了GPS定位系统，并与城市公共自行车服务站相结合。定位范围覆盖全市，精准度在100%，通过结合长兴县目前为公共自行车提供技术的江苏宏博科技有限公司的定点技术可以做到首尾一致。随着小品出行公共电助车的投放，市民必然对自己的出行方式进行调整，小品出行公共电助车因为其体型小巧，不会占用过多的停放面积。
          </span>
        </div>
      </div>
      <div class="xpTraffic_detail">
        <img src="../assets/traffic_pressure.png" alt="">
      </div>
    </div>
    <div id="xpDownload" class="xpDownload">
      <div class="phoneBg"></div>
      <div class="xpTit"><span>邀您体验 <br> 欢迎下载小品单车</span></div>
      <div class="downBotten" @click="downLoad"></div>
      <div class="qrcord"></div>
    </div>
    <div id="xpFocus" class="xpFocus">
      <p class="xpFocus_tit"><span>关于我们</span></p>
      <p class="xpFocus_detail"><span>小品电助车优势</span></p>
      <div class="detail_box">
        <div class="item">
          <img src="../assets/focusUnion.png" alt="">
          <div class="itemExplain">
            <p>强强联合</p>
            <p>与超威联手</p>
          </div>
          <div class="text">
            小品出行公共电助车与浙江超威集团签订战略合作协议，双方在电池采购、电池管理、电池回收上达成共识，并积极探索业务合作新模式。
          </div>
        </div>
        <div class="item">
          <img src="../assets/newPattern.png" alt="">
          <div class="itemExplain">
            <p>停车新模式</p>
            <p>全新自行车管理系统</p>
          </div>
          <div class="text">
            小品出行公共电助车全部接入政府主导的公共自行车管理系统，实行同站点分区停放。便于政府集中管理并监控。
          </div>
        </div>
        <div class="item">
          <img src="../assets/deposit_management.png" alt="">
          <div class="itemExplain">
            <p>免押出行</p>
            <p>实名认证享无忧出行</p>
          </div>
          <div class="text">
            小品出行对所有新注册的用户采取免押金的政策， 扫码出行，资金安全有保障，尊享极致体验。
          </div>
        </div>
      </div>
    </div>
    <div class="operationPattern">
      <div class="operationPattern_tit">
        <p><span>Operational model</span></p>
        <p><span>小品出行公共电助车运营模式</span></p>
      </div>
      <div class="operationPattern_cont">
        <img src="../assets/operateBg.png" alt="">
        <div class="model">
          <div class="modelTit"><img src="../assets/useIcon.png" alt=""><span>使用</span></div>
          <p class="model_text"><span>用户通过在政府公共停车点找到小品出行公共电助车，通过扫码注册、身份证实名注册。16岁以下70周岁以上无法通过验证注册，禁止使用。通过扫码成功开车锁后，骑行至目的地附近的公共停车点，停放车辆。支付车辆使用费锁车后离开。</span></p>
          <div class="modelTit"><img src="../assets/fee_standard.png" alt=""><span>收费标准</span></div>
          <p class="model_text"><span>小品出行针对市区投放，首里程20分钟2元，20分钟后每5分钟1元，不到5分钟按5分钟计费，从车辆解锁开始计费，中途临停也计费在内，只有将车辆停入规定位置内听到“还车成功”便可终止计费。</span></p>
          <div class="modelTit"><img src="../assets/yunying.png" alt=""><span>运营</span></div>
          <p class="model_text"><span>小品出行根据城市主管部门的考核要求设立有效、完善的运维体系。本着为广大市民和游客提供更加便利出行的宗旨和使命，成立专业的运营团队，24小时轮班对点位进行巡查和维护小品公共电助车，保证小品出行电助车的干净整洁及使用状态良好。</span></p>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer_top">
        <!-- <div>
          <p><span>小品助力 坐享骑程</span></p>
          <p><span>ENJOY TIME</span></p>
        </div> -->
      </div>
      <div class="footer_bottem">
        <p><img src="../assets/logo1.png" alt=""></p>
        <div class="footer_detail">
          <p>400 105 6680</p>
          <p>浙江省湖州市吴兴区区府路1188号总部自由港H幢16楼</p>
          <p>浙江本源质品信息科技股份有限公司</p>
          <p @click="toR('https://beian.miit.gov.cn/')">浙ICP备19007528号-1</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PC',
  mounted () {
    console.log((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)))
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      this.$router.push({path: '/mobile'})
    }
    const that = this
    this.handleScroll()
    window.addEventListener(
      'resize',
      function () {
        that.screenHeight = window.innerHeight
        that.setSize()
      },
      false
    )
    if (document.createEvent) {
      var event = document.createEvent('HTMLEvents')
      event.initEvent('resize', true, true)
      window.dispatchEvent(event)
    } else if (document.createEventObject) {
      window.fireEvent('onresize')
    }
    window.addEventListener('scroll', this.handleScroll, true)
  },
  data () {
    return {
      headerTop: false,
      routerList: [
        {tit: '首页', active: true, url: 'pc_top'},
        {tit: '小品出行', active: false, url: 'xpadVantage'},
        {tit: '下载APP', active: false, url: 'xpDownload'},
        {tit: '关于我们', active: false, url: 'xpFocus'}
      ]
    }
  },
  methods: {
    setSize: function () {
      document.documentElement.style.fontSize = ((window.innerWidth > 1100 ? window.innerWidth : 1100) / 1920) * 100 + 'px'
    },
    handleScroll (e) {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 50) {
        this.headerTop = true
      } else {
        this.headerTop = false
      }
    },
    toRouter (i) {
      this.routerList.forEach(function (value, e) {
        value.active = false
        if (e === i) {
          value.active = true
          document.getElementById(value.url).scrollIntoView({'behavior': 'smooth'})
        }
      })
    },
    toR (url) {
      window.location.href = url
    },
    downLoad () {
      window.location.href = 'http://h5s.pin-bike.com/down.html'
    }
  }
}
</script>
<style scoped>
.pc{
  width: 100%;
  min-width: 1100px;
  overflow: hidden;
}
.pc *{
    box-sizing: border-box;
}
p{
    margin: 0;
}
.header{
  width: 100%;
  min-width: 1100px;
  height: 1rem;
  padding:0 1.8rem 0 3.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 10;
}
.header .h_cont{
  height: 0.608rem;
  line-height: 0.608rem;
  float: left;
}
.header .h_cont .logo{
  width: 2.208rem;
  height: 0.624rem;
  background-image: url('../assets/logo.png');
  background-repeat: no-repeat;
  background-size: cover;
}
.header .h_cont .logo.headerTop{
  background-image: url('../assets/logo1.png');
}
.header .tipBox{
  width: 7.61rem;
  height: 1.66rem;
}
.header .tip{
  height: 100%;
  width: 4.10rem;
  margin:0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.17rem;
  font-weight:400;
  color:rgba(255,255,255,0.5);
}
.header .tip span:hover{
  cursor: pointer;
}
.header .tip.tipcolor{
  color: rgba(102,102,102,0.5);
}
.header .tip .active{
  font-weight:600;
  color:rgba(255,255,255,1);
}
.header .tip.tipcolor .active{
  font-weight:600;
  color:#666666;
}
.pc .pc_top_box{
  position: relative;
}
.pc .pc_top{
  height:11.13rem;
  padding:2.36rem 1.8rem 0 3.6rem;
  background-image: url('../assets/banner.png');
  background-repeat: no-repeat;
  background-size: 100%, auto;
}
.pc_top_cont{
  overflow: hidden;
}
.pc_top_cont>div:nth-of-type(1){
    width: 7.6rem;
    float: right;
}
.pc_top_cont>div:nth-of-type(2){
    padding:1.01rem 0 0 0;
    float: left;
}
.pc_top_cont>div>img{
    width: 100%;
}
.pc_top_cont .pc_cont{
    text-align: left;
}
.pc_cont .pc_cont_box{
    width: 5.45rem;
    height: 2.1rem;
    line-height:0.9rem;
}
.pc_cont_tit{
    font-size:0.64rem;
    font-weight:500;
    color:rgba(255,255,255,1);
}
.pc_cont_tip{
    font-size: 0.4rem;
    font-weight:300;
    color:rgba(255,255,255,1);
}
.pc_cont_text{
   font-size:0.18rem;
   font-weight:400;
   color:rgba(255, 255, 255, 0.5);
   line-height:0.34rem;
}
.pc_top_bottem{
    position: relative;
    left: 50%;
    bottom: 0.1rem;
    -webkit-transform: translate(-50%,0%);
    -ms-transform: translate(-50%,0%);
    transform: translate(-50%,0%);
    font-size:0.16rem;
    font-weight:600;
    color:rgba(126,128,133,1);
    line-height:0.22rem;
}
.xpadVantage .xpadVantage_tit{
  display: flex;
  justify-content: center;
  align-items: center;
}
.xpadVantage .xpadVantage_tit>p{
  width: 5.52rem;
  height: 0.64rem;
  color: #2C2E30;
  font-size:0.34rem;
  text-align: center;
  font-weight: 600;
  line-height: 0.64rem;
}
.xpadVantage .xpadVantage_detail{
  height: 4.19rem;
  /* background-color: aqua; */
  padding:0 3.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.xpadVantage_detail .hr{
  height: 0;
  width: 12rem;
  position: absolute;
  bottom: 0rem;
  left: 50%;
  -webkit-transform: translate(-50%,0%);
  -ms-transform: translate(-50%,0%);
  transform: translate(-50%,0%);
  border-bottom: 0.01rem solid #E7EAEE;
}
.xpadVantage_detail .item_title{
  font-size:0.24rem;
  font-weight:600;
  color:rgba(44,46,48,1);
  line-height:0.33rem;
  text-align: left;
}
.xpadVantage_detail .detail_item:nth-of-type(1) img{
  width: 0.39rem;
  height: 0.39rem;
  vertical-align:middle;
  margin-right:0.28rem;
}
.xpadVantage_detail .detail_item:nth-of-type(2) img{
  width: 0.4rem;
  height: 0.35rem;
  vertical-align:middle;
  margin-right:0.24rem;
}
.xpadVantage_detail .detail_item:nth-of-type(3) img{
  width: 0.36rem;
  height: 0.2rem;
  vertical-align:middle;
  margin-right:0.24rem;
}
.xpadVantage_detail .item_text{
  width: 3.2rem;
  height: 2.6rem;
  padding-top: 0.2rem;
  /* background-color: #999; */
  font-size:0.16rem;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:0.28rem;
  text-align: left;
}
.xpTraffic {
  height: 6.05rem;
  padding:0 3.6rem;
  /* background-color: aquamarine; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.xpTraffic .xpTraffic_detail{
  width: 5.99rem;
  height: 3.82rem;
  /* background-color: #E7EAEE; */
  text-align: left;
}
.xpTraffic .xpTraffic_detail:nth-of-type(1){
  padding-top: 0.34rem;
}
.xpTraffic_detail .explain{
  font-size:0.16rem;
  font-weight:600;
  color:rgba(126,128,133,1);
  line-height:0.22rem;
}
.xpTraffic_detail .xpTraffic_title{
  font-size:0.34rem;
  font-weight:600;
  color:rgba(44,46,48,1);
  line-height:0.46rem;
  margin-top: 0.1rem;
}
.xpTraffic .xpTraffic_text{
  width: 5.07rem;
  font-size:0.16rem;
  margin-top:0.68rem;
  font-weight:400;
  color:rgba(84,86,90,1);
  line-height:0.28rem;
}
.xpTraffic_detail>img{
  width: 5.41rem;
}
.xpDownload {
  width: 19.2rem;
  height: 7.23rem;
  background-image: url('../assets/downloadBg.png');
  background-repeat: no-repeat;
  background-size: 19.2rem auto;
  position: relative;
}
.xpDownload .phoneBg{
  width: 5.42rem;
  height: 7.82rem;
  background-image: url('../assets/phoneBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top:0.32rem;
  left: 8.61rem;
  z-index: 1;
}
.xpDownload .xpTit{
  width: 2.72rem;
  font-size:0.34rem;
  font-weight:'Semibold';
  color:rgba(255,255,255,1);
  line-height:0.46rem;
  text-align: left;
  position: absolute;
  top:1.12rem;
  left:4.65rem;
}
.xpDownload .downBotten{
  width: 1.97rem;
  height: 0.6rem;
  background-image: url('../assets/downloadButton.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top:2.36rem;
  left: 4.65rem;
}
.xpDownload .downBotten:hover{
  cursor: pointer;
  opacity: 0.8;
}
.xpDownload .qrcord{
  width: 2.24rem;
  height: 2.24rem;
  background-image: url('../assets/eqCord.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top:4.06rem;
  left: 4.65rem;
}
.xpFocus {
  width: 19.2rem;
  height: 8.17rem;
  background-image: url('../assets/focusBg.png');
  background-repeat: no-repeat;
  background-size: 19.2rem auto;
  position: relative;
  padding-top:2.12rem;
}
.xpFocus .xpFocus_tit{
  font-size:0.16rem;
  font-weight:400;
  color:rgba(126,128,133,1);
  line-height:0.22rem;
}
.xpFocus .xpFocus_detail{
  font-size:0.34rem;
  font-weight:600;
  color:rgba(44,46,48,1);
  line-height:0.46rem;
  margin: 0.1rem 0;
}
.xpFocus .detail_box{
  width: 19.2rem;
  padding: 0 3.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top:4.13rem;
  left: 0;
}
.xpFocus .detail_box .item{
  width: 3.6rem;
  height: 4.49rem;
  background:rgba(255,255,255,1);
  box-shadow:0px 0.02rem 0.09rem 0px rgba(0,0,0,0.14);
  border-radius:0.05rem;
  position: relative;
}
.xpFocus .detail_box .item:hover{
  cursor: pointer;
  opacity:0.8;
 }
.xpFocus .detail_box .item>img{
  width: 1.08rem;
  height: 1.08rem;
  position: absolute;
  left: 50%;
  top: 0.56rem;
  -webkit-transform: translate(-50%,0%);
  -ms-transform: translate(-50%,0%);
  transform: translate(-50%,0%);
}
.xpFocus .detail_box .itemExplain{
  width: 1.08rem;
  width: 100%;
  position: absolute;
  top:2.01rem;
  font-size: 0.24rem;
  font-weight:600;
  line-height:0.34rem;
}
.xpFocus .detail_box .itemExplain>p:nth-of-type(1){
  color: #2C2E30;
}
.xpFocus .detail_box .itemExplain>p:nth-of-type(2){
  color: #2F5BEA;
}
.xpFocus .detail_box .text{
  width: 3.16rem;
  position: absolute;
  left: 50%;
  top: 2.81rem;
  -webkit-transform: translate(-50%,0%);
  -ms-transform: translate(-50%,0%);
  transform: translate(-50%,0%);
  color: #999999;
  font-size:0.16rem;
  font-weight:400;
  line-height:0.28rem;
}
.operationPattern{
  width: 19.2rem;
  height: 12.68rem;
  background-repeat: no-repeat;
  background-size: 19.2rem auto;
  position: relative;
}
.operationPattern .operationPattern_tit{
  width: 100%;
  position: absolute;
  top:2.45rem;
  color: #7E8085;
  font-size:0.16rem;
  font-weight:600;
  line-height:0.22rem;
}
.operationPattern .operationPattern_tit>p:nth-of-type(2){
  color: #2C2E30;
  font-size:0.34rem;
  font-weight:600;
  line-height:0.46rem;
  margin:0.27rem 0;
}
.operationPattern .operationPattern_cont{
  width: 100%;
  padding:0 3.6rem;
  display: flex;
  justify-content: space-between;
  align-items: top;
  position: absolute;
  top: 4.78rem;
}
.operationPattern .operationPattern_cont>img{
  width: 7.49rem;
  height: 5.67rem;
}
.operationPattern .operationPattern_cont .model{
  width: 3.66rem;
  height: 6rem;
  /* background-color: #2F5BEA; */
  text-align: left;
}
.operationPattern .model img{
  vertical-align:middle;
}
.operationPattern .model img:nth-of-type(1){
  width: 0.38rem;
  height: 0.37rem;
  margin-right: 0.11rem;
}
.operationPattern .model img:nth-of-type(2){
  width: 0.31rem;
  height: 0.37rem;
  margin-right: 0.18rem;
}
.operationPattern .modelTit{
  font-size:0.24rem;
  font-weight:600;
  line-height:0.33rem;
  color: #2C2E30;
}
.operationPattern .model_text{
  font-size:0.16rem;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:0.28rem;
  margin: 0.2rem 0 0.3rem 0;
}
.footer{
  /* height: 8.03rem; */
}
.footer .footer_top{
  height: 2.8rem;
  background-image: url('../assets/xpzlBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  font-size:0.72rem;
  font-weight:600;
  color:rgba(255,255,255,1);
  line-height:1rem;
}
.footer .footer_top>div{
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.footer .footer_top p:nth-of-type(2){
  font-size:0.56rem;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:0.69rem;
  margin-top: 0.3rem;
}
.footer .footer_bottem{
  height: 2.8rem;
  padding-bottom:0.4rem;
  position: relative;
}
.footer .footer_bottem>p:nth-of-type(1) img{
  width: 2.009rem;
  height: 0.567rem;
}
.footer .footer_detail{
  font-size:0.16rem;
  font-weight:400;
  line-height:0.25rem;
  color: #666666;
}
.footer .footer_detail p{
  margin: 0.08rem 0;
}
.footer .footer_detail p:hover{
  cursor: pointer;
  opacity: 0.8;
  /*  */
  color: #2F5BEA;
}
</style>



// WEBPACK FOOTER //
// src/components/PC.vue